import { render, staticRenderFns } from "./FontFromFile.vue?vue&type=template&id=36a90a6c"
import script from "./FontFromFile.vue?vue&type=script&lang=js"
export * from "./FontFromFile.vue?vue&type=script&lang=js"
import style0 from "./FontFromFile.vue?vue&type=style&index=0&id=36a90a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports